import { CircularProgress } from "@mui/material";
import { FC } from "react";
import "./CustomCircularLoader.scss";
import useBlockInteraction from "../../hooks/useBlockInteraction";

interface Props {
  size?: number;
  marginRight?: string;
  marginLeft?: string;
  color?: string;
}

const CustomCircularLoader: FC<Props> = ({
  size = 32,
  marginRight = "",
  marginLeft = "",
  color = "#c7222a",
}) => {
  useBlockInteraction(true);
  return (
    <>
      <CircularProgress
        size={size}
        className="custom-circular-loader"
        style={{
          marginRight: marginRight,
          color: color,
          marginLeft: marginLeft,
        }}
      />
      {/* <div
        className="circular-loader-overlay"
        onClick={(e) => {
          e.stopPropagation();
        }}
      ></div> */}
    </>
  );
};

export default CustomCircularLoader;
